import React, { useState } from 'react';
import {
  useForm,
  Form,
  Input,
  Edit,
  Col,
  Row,
  RefreshButton,
  ListButton,
  Space,
  Button,
  useModalForm,
} from '@pankod/refine-antd';
import type { HttpError, OpenNotificationParams } from '@pankod/refine-core';

import { SubmissionTypes } from 'interfaces';

import { LeadModal } from 'components';
import { FORM_STATUS } from 'constant';

const SubmissionEdit: React.FC = () => {
  const [status, setStatus] = useState<string>('');
  const { formProps, saveButtonProps, queryResult } = useForm<
    SubmissionTypes,
    HttpError,
    SubmissionTypes
  >({
    metaData: {
      resource: 'formSubmissions',
      fields: [
        'id',
        'name',
        'email',
        'phone',
        'country',
        'company',
        'message',
        'status',
      ],
    },
    errorNotification(error: any, variables, context): OpenNotificationParams {
      return {
        message: error?.response?.errors[0]?.message,
        type: 'error',
      };
    },
  });

  // Create Modal
  const {
    modalProps: createModalProps,
    formProps: createFormProps,
    show: createModalShow,
  } = useModalForm<any>({
    action: 'create',
    resource: 'leads',
    warnWhenUnsavedChanges: true,
  });

  const { data, isLoading }: any = queryResult;
  const record = data?.data;

  return (
    <Edit
      isLoading={isLoading}
      saveButtonProps={saveButtonProps}
      headerProps={{
        extra: (
          <Space>
            <Button
              style={{
                backgroundColor: 'red',
                color: 'white',
                borderColor: 'red',
              }}
              type='dashed'
              onClick={
                record?.status === FORM_STATUS.SPAM
                  ? undefined
                  : () => {
                      createModalShow();
                      setStatus(FORM_STATUS.SPAM);
                    }
              }
            >
              {record?.status === FORM_STATUS.SPAM
                ? 'Marked As Spam'
                : 'Mark As Spam'}
            </Button>
            <Button
              type='primary'
              onClick={
                record?.status === FORM_STATUS.LEAD
                  ? undefined
                  : () => {
                      createModalShow();
                      setStatus(FORM_STATUS.LEAD);
                    }
              }
            >
              {record?.status === FORM_STATUS.LEAD
                ? 'Marked As Lead'
                : 'Mark As Lead'}
            </Button>
            <ListButton />
            <RefreshButton onClick={() => queryResult?.refetch()} />
          </Space>
        ),
      }}
    >
      <Form
        {...formProps}
        layout='vertical'
        onFinish={(values) =>
          formProps.onFinish?.({
            ...values,
          } as any)
        }
      >
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label='Name'
              name='name'
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label='Email'
              name='email'
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input disabled />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={8}>
            <Form.Item
              label='Phone'
              name='phone'
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item label='Country' name='country'>
              <Input />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label='Company' name='company'>
              <Input />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item
          label='Message'
          name='message'
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input.TextArea rows={4} />
        </Form.Item>
      </Form>
      <LeadModal
        createModalProps={createModalProps}
        createFormProps={createFormProps}
        id={record?.id}
        status={status}
      />
    </Edit>
  );
};

export default SubmissionEdit;
